module.exports = __webpack_public_path__ + "static/media/Untitled-2.17e3a7ac.png";